import {getFunctions, httpsCallable} from "firebase/functions";
import {app} from "../firebase";
import {API_KEY} from "../components/CONSTANTS";
import {
    updateLeadPandaDocValue,
    updateLeadPandaSessionValue,
    updateLeadPandaStatus,
    updatePDFFileName
} from "./Leadservice";


const functions = getFunctions(app);

export const getAPILogs = httpsCallable(functions, 'getPandadocAPILogs');


export const getApiLogsClient = async () => {
    return getAPILogs();
}

export const getDocuments = () => {

    let value = "https://api.pandadoc.com/public/v1/documents";


    fetch(value, {
        method: 'GET',
        headers: {
            "Authorization": API_KEY,
            "content-type": "application/json"
        }
    })
        .then(response => response.text())
        .then(result => console.log(result))
        .catch(error => console.log('error', error));
}







export const downloadFinishedFile = async (id) => {
    let myHeaders = new Headers();
    myHeaders.append("Authorization", API_KEY);
    myHeaders.append("Cookie", "incap_ses_631_2627658=8RdpbZd/IlzOCvDQwcPBCBpkAmIAAAAAL0BBxl8MOky8y+RMfdonzA==; nlbi_2627658=7WE5AbEC4jw8MJjzsee3lAAAAADqqHSrt7nQAuf/0PTA9A4a; visid_incap_2627658=r8Sg6lhgQJey9QeceTn/rzNjAmIAAAAAQUIPAAAAAACC0A02xFyTAQXGoNQgWpHt; AWSALB=7amMqKUvMx++U8DBhTrd+6l54QqDbzYn50JRu6SQctX1+Epf48jMBrC2m914gUH9qzdYXW6Kq6xjdeolIqHiaKUc4FNyayLv1Dl5ruXyaBgzskSlWqTXApA3gKrn; AWSALBCORS=7amMqKUvMx++U8DBhTrd+6l54QqDbzYn50JRu6SQctX1+Epf48jMBrC2m914gUH9qzdYXW6Kq6xjdeolIqHiaKUc4FNyayLv1Dl5ruXyaBgzskSlWqTXApA3gKrn");

    let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    fetch(`https://api.pandadoc.com/public/v1/documents/${id}/download`, requestOptions)
        .then(response => response.blob())
        .then((blob) => {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('Ladda ner');
            document.body.appendChild(link);

            link.click();

            link.parentNode.removeChild(link);
        })
}
export const createPandaDocFromTemplate =
    async (fsdocid
        , customerEmail
        , firstname
        , lastname
        , amountRef
        , senderEmail
        , service
        , company
    ) => {

        var myHeaders = new Headers();
        myHeaders.append("Authorization", API_KEY);
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Cookie", "incap_ses_1211_2627658=fjdwDHQDoEGbQ/OHnFbOEA4/CmIAAAAAaBgqiJxe5XK1JbH+6LLtpw==; nlbi_2627658=Jcp0Hcroz1C0v2gEsee3lAAAAABnVwAXubVJyM8e6oS2TB/p; visid_incap_2627658=A+QFI6+EQYunLFMQaey92w0/CmIAAAAAQUIPAAAAAAAitUvsIi1/OaeIWjBWGtLF; AWSALB=OTVra/kDnauSKLtEoAQxwT9ESO+wQP1SYGzDzc+hICCS+ZZuhZa5z8njlzGzZaTFJTV3eFTrinCrsBYd5dhJgFX5ZfG1Lt3zkpTofSrn4RjikR8xlu98Zj30n9re; AWSALBCORS=OTVra/kDnauSKLtEoAQxwT9ESO+wQP1SYGzDzc+hICCS+ZZuhZa5z8njlzGzZaTFJTV3eFTrinCrsBYd5dhJgFX5ZfG1Lt3zkpTofSrn4RjikR8xlu98Zj30n9re");

        let raw = JSON.stringify({

            "name": "Offert",
            "template_uuid": "uvMuAH8DNb6EEy9rLBybtZ",
            "recipients": [
                {
                    "email": customerEmail,
                    "first_name": firstname,
                    "last_name": lastname,
                    "role": "Reciever"
                },
                {
                    "email": senderEmail,
                    "role": "Sender",
                    "company": company
                }
            ],
            "tokens": [
                {
                    "name": "amount",
                    "value": amountRef

                },
                {
                    "name": "service",
                    "value": service
                }
            ],


        });

        let requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://api.pandadoc.com/public/v1/documents", requestOptions)
            .then(response =>
                response.json()
            )

            .then(async function (result) {


                let id = result['id']


                if (id) {
                    await updateLeadPandaDocValue(fsdocid, id);
                } else {
                    return "Ett feluppstod"
                }
            })
            .catch(() => console.error());
    }


export const attachFileToPandaDoc = async (id, file) => {


    let myHeaders = new Headers();
    myHeaders.append("Authorization", API_KEY);
    myHeaders.append("Cookie", "incap_ses_144_2627658=Ypmre6jYC0DnLFHAw5f/AamQ3mEAAAAAQrofOe9E46IxgonyjCj6fw==; nlbi_2627658=QNETQExuEDRg6amqsee3lAAAAABOm5oHcj0m07hEvjwS+lsE; visid_incap_2627658=VpIyPuNFRP2q7pr5RGQ0HDsz3WEAAAAAQUIPAAAAAABPJ1lLtkaFOo2ZgTrPHGud; AWSALB=bwdLFijsiXYTUi52f8keERza+MeVHfq8BsRZ/OtS7/HN5+b0F0PYWRTI/FhaQjl0JWpHwpbkVQjO7g/XnIt+uOYUtIwzOoXHs1iCJDUzASVEs2Dyhuek8Y8prs3Z; AWSALBCORS=bwdLFijsiXYTUi52f8keERza+MeVHfq8BsRZ/OtS7/HN5+b0F0PYWRTI/FhaQjl0JWpHwpbkVQjO7g/XnIt+uOYUtIwzOoXHs1iCJDUzASVEs2Dyhuek8Y8prs3Z");


    const formdata = new FormData();
    formdata.append("file", file);
    formdata.append("name", `${file.name}`)

    let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`https://api.pandadoc.com/public/v1/documents/${id}/attachments/`, requestOptions)
        .then(response => response.text())
        .then(result => {
        })
        .catch(error => console.log('error', error));

}


export const downloadFileFromPandadocAPI = async (id) => {


    const url = `https://api.pandadoc.com/public/v1/documents/${id}/download`;

    const myHeaders = new Headers();
    myHeaders.append("Authorization", "API-Key aadd5f8b42da8c9b1ae2d68dbb36bf94689c2629");
    myHeaders.append("Cookie", "visid_incap_2294548=BtQR9JECTjuXRfn8iYn7onGbwGEAAAAAQUIPAAAAAAA/6PIIzsySkIzauA00b89l; visid_incap_2627658=ZZ1kMNniQ4iStUho/Yb+lCWYqGEAAAAAQUIPAAAAAAAvsVScb4jwOtyZXmvl0/8R");

    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    fetch(url, requestOptions)
        .then(response => response.text())
        .then(result => console.log(result))
        .catch(error => console.log('error', error));
}

export const checkDocumentStatus = async (fsdocid, id) => {

    let data = null;
    let pandaUrl = `https://api.pandadoc.com/public/v1/documents/${id}`
    let headers = new Headers();
    headers.append("Authorization", API_KEY);
    headers.append("Cookie", "incap_ses_892_2294548=eZGKRU+EJ26yo3bBcghhDCyxuWEAAAAAoDUDNZNFe9YBn8RVTCYL0g==;" +
        " incap_ses_892_2627658=iYSGBIkNEwEsh77BcghhDOX4uWEAAAAALytdbzDG2uTgtA8ppJe90w==; nlbi_2294548=z3+yK8FrG2nYsCYmtR42TwAAAAC2+ZEwMUTsyxdkiO10f3MW; nlbi_2627658=CODNYxk8mCrgY5JLsee3lAAAAABpZR0/pVnu0aJFvxZCRRDa; visid_incap_2294548=+DZzv7N5SQWej3sPBkTs2jx7imEAAAAAQUIPAAAAAADnIuF+V6AfMyrX7jxhvH2P; visid_incap_2627658=x0azS48HSGyTluYoShN2EcJ5imEAAAAAQUIPAAAAAABzXL5htejS410Dl9BIZ8eK; AWSALB=o31W4oxInjq+ir1wm7kxtI8025uFXKSBKtRZCEAQbrJ2NJfh+eCdrctdSyAEVNg13Xd6A3IyvlyqFb1ZarG5U3x0d477aQx3CiVHZvqFmXijlFEVzcHU1FlPZBMEKTkeHIu0hueG3towOaFZCfg9LPUjV1YwArAwJJ1IPTIgQZvy+8YJ/bjHpxPkD5h+rw==; AWSALBCORS=o31W4oxInjq+ir1wm7kxtI8025uFXKSBKtRZCEAQbrJ2NJfh+eCdrctdSyAEVNg13Xd6A3IyvlyqFb1ZarG5U3x0d477aQx3CiVHZvqFmXijlFEVzcHU1FlPZBMEKTkeHIu0hueG3towOaFZCfg9LPUjV1YwArAwJJ1IPTIgQZvy+8YJ/bjHpxPkD5h+rw==");


    var requestOptions = {
        method: 'GET',
        headers: headers,
        redirect: 'follow'
    };

    await fetch(pandaUrl, requestOptions)
        .then(response =>
            response.json())
        .then(result => {
            data = result;
            updateLeadPandaStatus(fsdocid, data.status, data.date_modified, data.date_completed, data.name, data.date_completed)
        })
        .catch(error => console.log("Error", error));

    return data;
}

export const setDocumentSent = async (id, email, firstname) => {
    let myHeaders = new Headers();
    myHeaders.append("Authorization", API_KEY);
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "incap_ses_481_2294548=aKbPRLGVbFTU6uVXf9usBslbwGEAAAAA8JNUkZEwmmpIVOr9PEzZSw==; incap_ses_481_2627658=sjAUakxZ6gwhsehXf9usBl1fwGEAAAAAd5Q051d4epVA/aQUl3HXWw==; nlbi_2294548=csZOVGgT8Hyd0eOQtR42TwAAAACb9707ARa1DpsCmkuXVGnR; nlbi_2627658=jZP4Hv6aEiXk0vbcsee3lAAAAADgrUVkhId9tYVGgto4Ywg1; visid_incap_2294548=+DZzv7N5SQWej3sPBkTs2jx7imEAAAAAQUIPAAAAAADnIuF+V6AfMyrX7jxhvH2P; visid_incap_2627658=x0azS48HSGyTluYoShN2EcJ5imEAAAAAQUIPAAAAAABzXL5htejS410Dl9BIZ8eK; AWSALB=IeSi6OdyJWe10E88L7uEf75mBIorGVPXsLRiqP5Ku6e4SZhTNj0XTV3Gmg0UwOQO76ssGE4gJ7Jnpzhdmq/tZZjVc90EORgUH/S/jPEkgdEHDOXw8EGSKPwsv2nbHebmfTNimQ7DQVRUcHQIntilvf89geAQms1+weJKFUB0PZaaaSdLqrjHSOgn5fldkA==; AWSALBCORS=IeSi6OdyJWe10E88L7uEf75mBIorGVPXsLRiqP5Ku6e4SZhTNj0XTV3Gmg0UwOQO76ssGE4gJ7Jnpzhdmq/tZZjVc90EORgUH/S/jPEkgdEHDOXw8EGSKPwsv2nbHebmfTNimQ7DQVRUcHQIntilvf89geAQms1+weJKFUB0PZaaaSdLqrjHSOgn5fldkA==");

    let raw = JSON.stringify({
        "message": `Hej ${firstname}, här kommer offerten ni har efterfrågat!`,
        "silent": false,
        "email": email
    });

    let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    fetch(`https://api.pandadoc.com/public/v1/documents/${id}/send`, requestOptions)
        .then(response => response.text())
        .then(result => {

        })
        .catch(error => console.log('error', error));


}

export const getPandaDocSessionID = async (fsID, id, email) => {


    let myHeaders = new Headers();
    myHeaders.append("Authorization", API_KEY);
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "incap_ses_481_2627658=nNaPfq9JPXC0Z+VXf9usBhdbwGEAAAAAjh5mkGkZuaD54cTa1GMe8Q==; nlbi_2627658=jZP4Hv6aEiXk0vbcsee3lAAAAADgrUVkhId9tYVGgto4Ywg1; visid_incap_2294548=+DZzv7N5SQWej3sPBkTs2jx7imEAAAAAQUIPAAAAAADnIuF+V6AfMyrX7jxhvH2P; visid_incap_2627658=x0azS48HSGyTluYoShN2EcJ5imEAAAAAQUIPAAAAAABzXL5htejS410Dl9BIZ8eK; AWSALB=59qiieQYBI6+r9jM8atizoEw56H7pFL6hwfDo2L5mblAtwf6QLvb1fhQ6TCC6gO5ecg037GayEIjeTOpiGuGcsDS/nF8ig9Kr0tudUj5dYeChOsjTEy32+tsZt42ZBRz8C7V1EoDe4QcJ9wDRN8mA6u1VnrQO11qsmNE9LIdlxv2pQ6jZjr8UT8wElx8xA==; AWSALBCORS=59qiieQYBI6+r9jM8atizoEw56H7pFL6hwfDo2L5mblAtwf6QLvb1fhQ6TCC6gO5ecg037GayEIjeTOpiGuGcsDS/nF8ig9Kr0tudUj5dYeChOsjTEy32+tsZt42ZBRz8C7V1EoDe4QcJ9wDRN8mA6u1VnrQO11qsmNE9LIdlxv2pQ6jZjr8UT8wElx8xA==");

    let raw = JSON.stringify({
        "recipient": email,
        "lifetime": 86000
    });

    let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    await fetch(`https://api.pandadoc.com/public/v1/documents/${id}/session`, requestOptions)
        .then(response => response.json())
        .then(result => {

            updateLeadPandaSessionValue(fsID, result.id)
        })
        .catch(error => console.log('error', error));

}
